import React from 'react';
import ContentBox from '../../common/ContentBox';
import { Box, Typography } from '@mui/material';
import { useAppSelector } from '../../../store/reducers/store';
import { useTranslation } from 'react-i18next';
import FundsAllocationLineGraph from './components/FundsAllocationLineGraph';
import PerformanceMetrics from './components/PerformanceMetrics';

const OverviewTab: React.FC = () => {
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    const { t, i18n } = useTranslation();
    if (portfolio === undefined){
        return <></>;
    }
    return <>
        <ContentBox proportion={4}>
            <Box display={"flex"} flexDirection={"column"} gap={"25px"}>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsFundsAllocation')}</Typography>
                    <Typography fontSize={"20px"} lineHeight={"24.38px"} fontWeight={"800"}>{`€${portfolio.fundraisingTarget.toLocaleString(i18n.language)}`}</Typography>
                </Box>
                <FundsAllocationLineGraph target={portfolio.fundraisingTarget} funds={portfolio.funds} />
            </Box>
        </ContentBox>
        <ContentBox proportion={1.7}>
            <Box display={"flex"} flexDirection={"column"} gap={"25px"}>
                <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsPerformanceMetrics')}</Typography>
                <PerformanceMetrics portfolio={portfolio} />
            </Box>
        </ContentBox>
    </>;
}

export default OverviewTab;